<section class="banner-area banner-area-two bg-2">
    <div class="container">
        <div class="banner-content">
            <!-- <span class="top-title">We Pursue Idea</span> -->
            <h1 class="font-family002"><span class="text-001">W</span>e Build Trust and Consistency<br/> With Our Clients</h1>
            <p class="font-family003">Bon<span class="text-001 font-weight6">T</span>on Provide the solution for safe and smart cities.</p>
            <a routerLink="/about" class="default-btn"><span>About Us</span></a>
        </div>
    </div>
</section>